/**
 * Après Hero — Carousel + smooth scroll to #purchase.
 */
(function () {
  'use strict';

  /* ── Carousel ── */
  document.querySelectorAll('[data-apres-carousel]').forEach(function (carousel) {
    var slidesContainer = carousel.querySelector('.apres-hero__slides');
    var slides = carousel.querySelectorAll('.apres-hero__slide');
    var dots = carousel.querySelectorAll('.apres-hero__dot');

    if (slides.length < 2 || !dots.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var index = Array.prototype.indexOf.call(slides, entry.target);
            dots.forEach(function (dot, i) {
              dot.classList.toggle('is-active', i === index);
            });
          }
        });
      },
      { root: slidesContainer, threshold: 0.6 }
    );

    slides.forEach(function (slide) {
      observer.observe(slide);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-slide-index'), 10);
        slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  });

  /* ── Smooth scroll to #purchase ── */
  document.querySelectorAll('[data-scroll-to-purchase]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.getElementById('purchase');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
})();
